/**
 * External Dependencies
 */

import Controller from './helpers/Controller';
import TextUpTransition from './components/TextUpTransition';
import Accordion from './components/Accordion';
import Slider from './components/Slider';
import Counter from './components/Counter';

import common from './controllers/common';
import HeaderNavigation from './components/HeaderNavigation';
import DropDownNavigation from './components/DropDownNavigation';
import AccordionMobile from './components/AccordionMobile';
import IsTitleWrap from './components/IsTitleWrap';
import AccordionTeam from './components/AccordionTeam';
import EntranceAnimation from './components/EntranceAnimation';

const modules = [Counter, common, Slider, Accordion, TextUpTransition, HeaderNavigation, DropDownNavigation, AccordionMobile, IsTitleWrap, AccordionTeam, EntranceAnimation];

const controller = new Controller(modules);
controller.ready();

// @note - this will popup a confirmation before leaving the page
// window.onbeforeunload = () => controller.destroy();
